export default __webpack_public_path__ + "static/media/phone-lumin-info.836ed048.jpg";